import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { useT } from "../i18n/LanguageContext";
import MethodTimeline from "../components/MethodTimeline";

export default function Method() {
  const t = useT();
  const root = useReveal();
  const steps = t("method.steps");

  return (
    <div ref={root} className="pt-32 md:pt-40">
      <section className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <p className="reveal eyebrow">{t("method.eyebrow")}</p>
            <h1 className="reveal reveal-delay-1 mt-8 font-serif text-5xl md:text-7xl lg:text-[6.5rem] tracking-tight text-[#1A1A1A] leading-[0.95]">
              {t("method.title")}
            </h1>
          </div>
          <div className="md:col-span-4 md:pb-3">
            <p className="reveal reveal-delay-2 text-lg text-[#4A4A4A] leading-relaxed">
              {t("method.intro")}
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#F3F1EA] border-y border-[rgba(26,26,26,0.06)] py-24 md:py-32">
        <div className="container-x">
          <MethodTimeline steps={steps} testIdPrefix="method-step" />
        </div>
      </section>

      <section className="container-x py-32 md:py-40 text-center">
        <div className="reveal max-w-3xl mx-auto">
          <p className="eyebrow justify-center inline-flex">
            {t("method.coda.eyebrow")}
          </p>
          <h2 className="mt-8 font-serif text-3xl md:text-5xl text-[#1A1A1A] tracking-tight leading-[1.05]">
            {t("method.coda.title")}
          </h2>
          <p className="mt-8 text-lg text-[#4A4A4A] leading-relaxed">
            {t("method.coda.body")}
          </p>
          <div className="mt-12">
            <Link to="/curriculum" className="btn-ink" data-testid="method-cta">
              Explore the Curriculum <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
